import { channelIcons } from 'domains/campaigns/pages/CurationsPage/utils';
import { CampaignChannels } from 'domains/campaigns/types';
import FormLayout from 'domains/core/components/FormLayout';
import VoiceCallMessageInput from './VoiceCallMessageInput';
import { VoiceTemplateState } from '../VoiceTemplateReducer';
import { VoiceTemplateAction } from '../VoiceTemplateActions';

type Props = {
    voiceTemplateState: VoiceTemplateState;
    voiceTemplateDispatchAction: React.Dispatch<VoiceTemplateAction>;
    isMessageLoading: boolean;
};

const VoiceCallMessage = ({
    voiceTemplateDispatchAction: dispatch,
    voiceTemplateState: state,
    isMessageLoading,
}: Props) => {
    const StepIcon = channelIcons[CampaignChannels.VOICE_CALL];

    return (
        <FormLayout
            header="Play Message"
            icon={<StepIcon />}
            guidingText="Enter the message your contact will hear when they pick up. Keep it clear, focused, and engaging to align with your goal."
            stepName="Voice call"
        >
            <VoiceCallMessageInput
                voiceTemplateState={state}
                voiceTemplateDispatchAction={dispatch}
                isMessageLoading={isMessageLoading}
            />
        </FormLayout>
    );
};

export default VoiceCallMessage;
